module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADEAAAAdCAMAAAA0LHRjAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAADBQTFRF2uvj0OXc2tvb8/Pz6PHsyNHM6OjpzN3VytfQ+vv74uLj1ung9Pf10dHR3u7p////L278DgAAAOlJREFUeNqU1AsOhCAMBNACFQVqvf9tF5EVdykIk5iYOC+Cn8IxG+heRcWTgpnBzQoGTKfEOCBcOAkHYDgPehEB4AJ3sC+Qq0BfsCCwK4JEuCOcJNKzlgTJ27gISULB4aAhAlaCMJaVagFTr6rVTVGLLqtyCDEIPbDu+25v0a0W4I9xAVsEWN4Hwwgw5Q3i65Ii0PT4SmBgD/rn/1DvwJd/kLizCaXWdduW+w5RUBDqIReXWM1x0kNNvb/iN6ZMBi61upejPT1mCem9WdTWoqH/6ePrnrfWGNeciTbXrh4NTFFnzNzc/QgwADXhSg407+mRAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/components/SP/assets/KY.png
// module id = pbkM
// module chunks = 1